import React from "react";
const ProfileImage = ({ imageURL }) => {
  if (imageURL){
    return (
      // <div className="profile-img">
        <img className="profile-img" src={ imageURL } alt="profile"/>
      // </div>
    );
  }
  return (
    <div className="profile-img-no">
      <div className="icon">
        <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M23.5 26.4375C30.7979 26.4375 36.7188 20.5166 36.7188 13.2188C36.7188 5.9209 30.7979 0 23.5 0C16.2021 0 10.2812 5.9209 10.2812 13.2188C10.2812 20.5166 16.2021 26.4375 23.5 26.4375ZM35.25 29.375H30.192C28.1541 30.3113 25.8867 30.8438 23.5 30.8438C21.1133 30.8438 18.8551 30.3113 16.808 29.375H11.75C5.25996 29.375 0 34.635 0 41.125V42.5938C0 45.0264 1.97363 47 4.40625 47H42.5938C45.0264 47 47 45.0264 47 42.5938V41.125C47 34.635 41.74 29.375 35.25 29.375Z" fill="#DADADA"/>
        </svg>
      </div>
    </div>
  );
};
export default ProfileImage;
